export default {
  POSITION: 'position',
  SCALE: 'scale',
  SRC: 'src',
  ORIGIN_SRC: 'origin-src',
  ORIGIN_WIDTH: 'origin-width',
  ORIGIN_HEIGHT: 'origin-height',
  ASPECT_RATIO: 'aspect-ratio',
};
